if (!customElements.get('gift-redeem-button')) {
  customElements.define(
    'gift-redeem-button',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.redeem.bind(this));
      }

      redeem() {
        if (!this.querySelector('img')) {
          this.textContent = 'Adding...';
        }
        this.style.pointerEvents = 'none';
        this.style.opacity = '0.5';

        // "Change" path: the current gift line goes first, then the new gift is
        // added. Adding by variant id keeps this safe against the line shift.
        const swapLine = parseInt(this.dataset.swapLine);
        if (swapLine > 0) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: swapLine, quantity: 0 }),
          })
            .then((r) => r.json())
            .then((data) => {
              if (data.status) throw new Error(data.description || data.message);
              this.add();
            })
            .catch(() => {
              this.style.pointerEvents = '';
              this.style.opacity = '';
            });
          return;
        }
        this.add();
      }

      add() {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(this.dataset.variantId),
                quantity: 1,
                properties: { _is_free: 'true' },
              },
            ],
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data.status) return;
            const drawer = document.querySelector('cart-drawer');
            if (drawer) drawer.renderContents(data);
          });
      }
    }
  );
}

if (!customElements.get('gift-choice-modal')) {
  customElements.define(
    'gift-choice-modal',
    class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;

        // Bind triggers (anywhere in the document) targeting this modal
        const targetId = this.dialog.id;
        this._onTriggerClick = (event) => {
          const trigger = event.target.closest(`[data-modal-target="${targetId}"]`);
          if (!trigger) return;
          event.preventDefault();
          this.show();
        };
        document.addEventListener('click', this._onTriggerClick);

        // Close on × button or backdrop click
        this.dialog.addEventListener('click', (event) => {
          if (event.target.closest('[data-close]')) {
            this.dialog.close();
            return;
          }
          // Backdrop click: clicking on dialog element itself (not its content)
          if (event.target === this.dialog) {
            this.dialog.close();
          }
        });

        // The snippet only renders this element while the gift is unlocked and
        // not yet in the cart, so "connected" already means "there is a pick to
        // make". Per the 10/20 call: show it every time the cart opens or
        // changes until a gift is picked - no dismissal memory. Closing it only
        // lasts until the next cart change or the next time the drawer opens.
        if (this.dataset.autoOpen === 'true') {
          this.autoOpen();
        }
      }

      disconnectedCallback() {
        if (this._onTriggerClick) {
          document.removeEventListener('click', this._onTriggerClick);
        }
        this.drawerObserver?.disconnect();
        this.drawerObserver = null;
        clearTimeout(this.openTimer);
      }

      show() {
        if (this.dialog.open) return;
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
      }

      // Every cart change re-renders the drawer, which reconnects this element:
      // if the drawer is showing, open now. Otherwise (page load with the gift
      // already unlocked, or the shopper closed and reopened the drawer) watch
      // the drawer's class and open on each closed -> open transition. The
      // observer stays alive for the life of the element, so reopening the
      // cart re-pops the chooser as well.
      autoOpen() {
        const drawer = this.closest('cart-drawer');
        if (!drawer) {
          this.openAfterTransition();
          return;
        }
        let wasActive = drawer.classList.contains('active');
        if (wasActive) this.openAfterTransition();
        this.drawerObserver = new MutationObserver(() => {
          const isActive = drawer.classList.contains('active');
          if (isActive && !wasActive) this.openAfterTransition();
          wasActive = isActive;
        });
        this.drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }

      // Let the drawer finish sliding in (--duration-default is 200ms) so the
      // dialog lands on a settled cart instead of mid-animation.
      openAfterTransition() {
        clearTimeout(this.openTimer);
        this.openTimer = setTimeout(() => this.openWhenClear(), 400);
      }

      // Only one modal at a time. If another dialog is up (the post-ATC upsell
      // layered over an in-drawer add), queue behind it and open when it closes.
      openWhenClear() {
        if (!this.isConnected || this.dialog.open) return;
        const other = document.querySelector('dialog[open]');
        if (other && other !== this.dialog) {
          other.addEventListener('close', () => this.openWhenClear(), { once: true });
          return;
        }
        this.show();
      }
    }
  );
}

if (!customElements.get('gift-auto-remove')) {
  customElements.define(
    'gift-auto-remove',
    class extends HTMLElement {
      connectedCallback() {
        const line = parseInt(this.dataset.line);
        this.remove();

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: line,
            quantity: 0,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data.status) return;
            const drawer = document.querySelector('cart-drawer');
            if (drawer) drawer.renderContents(data);
          });
      }
    }
  );
}
